import { maxWidth } from "components/mediaqueries.ts";
const CARD_HEIGHT = "234px";
export const styles: any = {
    AppStoreCardStyles: {
        position: "relative",
        height: "calc(50% - {{space.1}})",
        [maxWidth[2]]: {
            height: "calc(100% - {{space.1}})",
            marginLeft: "0 !important",
            marginBottom: 2,
        },
    },
    AppStoreTextStyles: {
        width: "40%",
        [maxWidth[1]]: {
            width: "100%",
        },
    },
    FeaturedCardStyles: {
        height: CARD_HEIGHT,
        borderRadius: 1,
        cursor: "pointer",
        transition: "0.3s",
        ":hover": {
            boxShadow: 4,
        },
        [maxWidth[1]]: {
            width: "100%",
            marginY: 3,
            overflow: "overlay",
        },
    },
    AppCardStyles: {
        cursor: "pointer",
        transition: "0.3s",
        height: "180px",
        width: "200px",
        objectFit: "cover",
        borderRadius: 2,
        ":hover": {
            boxShadow: 2,
        },
    },
    ImageStyles: {
        height: "180px",
        width: "200px",
        objectFit: "cover",
    },
    OverviewTextStyles: {
        paddingY: 2,
        width: "50%",
        [maxWidth[0]]: {
            width: "100%",
        },
    },
    TopAppsStyles: {
        justifyContent: "flex",
        marginY: 4,
        [maxWidth[0]]: {
            justifyContent: "center",
        },
    },
    SampleAppDetail: {
        marginY: 3,
    },
    SampleAppDetailContainer: {
        [maxWidth[0]]: {
            margin: "auto",
        },
    },
    VerticalLine: {
        borderLeft: "1px solid {{colors.white}}",
        position: "absolute",
        height: CARD_HEIGHT,
        marginLeft: "15%",
        "@media(max-width: 460px)": {
            display: "none",
        },
        "@media(max-width: 860px)": {
            display: "none",
        },
    },
};
